import type { ProductType, SectionType } from '~/utils/api/common';

export const useCommonStore = defineStore('common', () => {
  const config = useRuntimeConfig();
  const userStore = useUserStore();
  const tokenStore = useTokenStore();

  const products = ref<ProductType[]>([]);
  const sections = ref<SectionType[]>([]);
  const isTestGroup = ref(config.public.isTestGroup);
  const isEmailAuthEnabled = ref(config.public.isEmailAuthEnabled);
  const ozonDeliveryEnabled = ref(false);
  const newDesign = ref(false);
  // Удалить вместе с временным переключателем после завершения эксперимента.
  const pendingGuestTransfers = ref(0);
  const guestTransferFailed = ref(false);
  let latestRequest = 0;

  watch(
    () => tokenStore.value,
    () => {
      newDesign.value = false;
    },
    { flush: 'sync' },
  );

  const fetchCommon = async () => {
    const requestToken = tokenStore.value;
    const request = ++latestRequest;
    const data = await CommonAPI.common();
    if (request === latestRequest && requestToken === tokenStore.value) {
      newDesign.value = !!requestToken && data.newdesign === true;
    }
    products.value = data.products;
    sections.value = data.sections;
    isTestGroup.value = data.isTestGroup || config.public.isTestGroup;
    isEmailAuthEnabled.value = data.isEmailAuthEnabled ?? config.public.isEmailAuthEnabled;
    ozonDeliveryEnabled.value = data.ozonDeliveryEnabled ?? false;

    return { products: products.value, sections: sections.value };
  };

  watch(
    () => userStore.authorized,
    (_, prev) => {
      if (import.meta.client && prev !== undefined) fetchCommon();
    },
  );

  return {
    products,
    sections,
    isTestGroup,
    isEmailAuthEnabled,
    ozonDeliveryEnabled,
    newDesign,
    pendingGuestTransfers,
    guestTransferFailed,

    fetchCommon,
  };
});
